export const isEmptyTestObject = (testObject) => {
    const length = testObject.usersCards.length

    return length === 0 ? true : false
}